$(document).ready(() => {
	$(".general-slider").each((index, element) => {
		const $this = $(element);
		const swiperContainer = $this.find(".swiper")[0];
		const swiperBtnPrev = $this.find(".swiper-btn-prev")[0];
		const swiperBtnNext = $this.find(".swiper-btn-next")[0];
		const swiperPagination = $this.find(".swiper-pagination")[0];
		const isLoop = $this.data("loop");
		const isAutoplay = $this.data("autoplay");
		const isCenterSlides = $this.data("center-slides");
		const isMobileCenterSlides = $this.data("mobile-center-slides");
		const slider = new Swiper(swiperContainer, {
			slidesPerView: "auto",
			centeredSlides: isCenterSlides ? true : false,
			watchSlidesVisibility: true,
			navigation: {
				prevEl: swiperBtnPrev,
				nextEl: swiperBtnNext,
			},
			pagination: {
				el: swiperPagination,
				clickable: true,
			},
			speed: 1000,
			watchOverflow: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			loop: isLoop,
			init: false,
			breakpoints: {
				"1024": {
					centeredSlides: isMobileCenterSlides ? true : false,
					spaceBetween: isMobileCenterSlides ? 16 : 0,
				}
			},
			autoplay: isAutoplay
				? {
					delay: isAutoplay,
					disableOnInteraction: true,
				}
				: false,
		});

		slider.init();
	});
});
